import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left: Image */}
          <div className="w-full lg:w-2/5">
            <span className="inline-block border border-foreground-300/40 text-foreground-500 text-xs px-3 py-1 rounded-full mb-4">
              关于我们
            </span>
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20social%20media%20app%20interface%20on%20wooden%20desk%2C%20warm%20ambient%20lighting%2C%20coffee%20cup%20nearby%2C%20plant%20decor%2C%20lifestyle%20photography%2C%20warm%20orange%20and%20cream%20tones%2C%20clean%20composition%2C%20editorial%20style&width=800&height=1000&seq=about-img-51chigua&orientation=portrait"
                alt="51吃瓜网站——关于我们"
                title="51吃瓜网站——最新网红明星爆料八卦"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Right: Text */}
          <div className="w-full lg:w-3/5">
            <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 font-black leading-tight mb-4">
              我们只想
              <br />
              让吃瓜变得
              <br />
              更简单
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-lg">
              51吃瓜网站成立于2024年，致力于打造最全最及时的娱乐八卦聚合平台。我们汇聚了来自全网的最新爆料、独家黑料和热门吃瓜内容，让每一位吃瓜群众都能第一时间获取最新鲜的瓜。
            </p>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8 max-w-lg">
              我们的团队由一群热爱吃瓜的资深网友组成，坚持"吃瓜不站队，理性看热闹"的原则，为大家筛选最真实、最劲爆的八卦资讯。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}